import React, { useState } from "react";
import { Minus, Plus } from "lucide-react";
import { SectionLabel } from "./SectionLabel";

export const faqItems = [
  {
    q: "How much does Pop Social Events cost?",
    a: "Our foundation bar package starts at $2,500 and includes professional bartending, a custom cocktail menu, premium garnishes, mixers, and ice. From there you layer on what your evening needs — extra service hours are $100/hour, an additional bar is $500, and our mobile charcuterie cart experience is $1,200. Use the quote calculator on this page for an instant estimate.",
  },
  {
    q: "Which areas of South Florida do you serve?",
    a: "We serve all of Miami-Dade, Broward, and Palm Beach counties — from Miami Beach and Coral Gables to Fort Lauderdale, Boca Raton, and West Palm Beach. Private residences, venues, offices, and waterfront properties are all welcome.",
  },
  {
    q: "Do you provide the alcohol?",
    a: "You purchase the spirits and we handle absolutely everything else — mixers, fresh juices, syrups, garnishes, ice, and the craft. This keeps your cost down and avoids liquor-license markups. Our calculator tells you exactly how many bottles of each spirit to buy for your guest count, so there's no guesswork.",
  },
  {
    q: "How many bartenders will my event need?",
    a: "We staff one professional bartender for every 50 guests, so lines never form and every drink is made properly. A 75-guest party gets two bartenders; a 150-guest wedding gets three.",
  },
  {
    q: "What is the charcuterie cart and grazing table service?",
    a: "Our signature mobile charcuterie cart brings artisanal cheeses, cured meats, seasonal fruit, and accompaniments directly to your guests, while grazing tables become an edible centrepiece. We accommodate allergens and dietary preferences — vegan, vegetarian, gluten-free, nut-free, and more — just flag them in your booking brief.",
  },
  {
    q: "How do I book and reserve my date?",
    a: "Submit the quote request on this page and we'll reply personally with a tailored quote. Once you're ready, a 50% deposit reserves your date — paid securely online by card. Popular weekends book quickly, so 3–6 weeks of lead time is ideal, though we accommodate shorter timelines when the calendar allows.",
  },
  {
    q: "Can you create a custom cocktail menu for my event?",
    a: "Absolutely — that's our favourite part. Choose from our vault of 58 pours — including a zero-proof collection for non-drinking guests — or work with us on bespoke creations, from clarified milk punches to spirit-free spritzes. A custom menu is included in every package.",
  },
  {
    q: "Are you available for weddings and corporate events?",
    a: "Yes — luxury weddings, corporate soirées, product launches, milestone birthdays, and intimate dinner parties are our specialty. White-glove service, polished presentation, and a bar program your guests will still be talking about on the drive home.",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);
  return (
    <section className="section faq-section" id="faq" data-testid="faq-section">
      <div className="section-intro reveal-on-scroll">
        <SectionLabel number="09" testId="faq-section-label">Questions, answered</SectionLabel>
        <div className="intro-grid">
          <h2 data-testid="faq-heading">Everything hosts ask before booking.</h2>
          <p data-testid="faq-description">The practical details behind the polish — pricing, staffing, spirits, and how to lock in your date.</p>
        </div>
      </div>
      <div className="faq-list reveal-on-scroll">
        {faqItems.map((item, index) => {
          const isOpen = open === index;
          return (
            <div className={`faq-item${isOpen ? " is-open" : ""}`} key={item.q}>
              <button type="button" className="faq-question" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-testid={`faq-question-${index}`}>
                <span>{item.q}</span>
                {isOpen ? <Minus size={17} /> : <Plus size={17} />}
              </button>
              {isOpen && <p className="faq-answer" data-testid={`faq-answer-${index}`}>{item.a}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
}
